import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import ConfigurePaymentGateways from "./ConfigurePaymentGateways";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AddIcon from "@mui/icons-material/Add";
import { pointerEvents } from "make-event-props";

const PspCard = ({
  filteredGateways,
  obj,
  pspSelected,
  setPspSelected,
  toggled,
  setToggled,
  getMethodsForPspAndType,
  payload,
  setPayload,
  off,
  setOff,
  storeCreds,
  setStoreCreds,
  setPspSaved,
  pspSaved,
  getSupportedMethods,
}) => {
  const [toggle, setToggle] = useState(false);
  const [unSaved, setUnSaved] = useState(true);
  const [showCreds, setShowcreds] = useState([{ value: obj.value }]);
  const [availableTypes, setAvailableTypes] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [gatewayConfigs, setGatewayConfigs] = useState([]);
  const [countrySelected, setCountrySelected] = useState([]);
  const [currenciesSelected, setCurrenciesSelected] = useState([]);
  let PspCode = obj.value;
  useEffect(() => {
    setShowcreds([{ value: obj.value }]);
    PspCode = obj.value;
  }, [filteredGateways]);

  useEffect(() => {
    setAvailableTypes((prevTypes) => {
      let newTypes = [];
      setShowOptions(true);
      const pspCode = PspCode;
      const cardOptions = getMethodsForPspAndType(pspCode, "Card");
      if (cardOptions.length > 0) {
        newTypes.push({ title: "Cards" });
      }

      const walletOptions = getMethodsForPspAndType(pspCode, "Wallet");
      if (walletOptions.length > 0) {
        newTypes.push({ title: "Wallet" });
      }

      const bnplOptions = getMethodsForPspAndType(pspCode, "BuyNowPayLater");
      if (bnplOptions.length > 0) {
        newTypes.push({ title: "BNPL" });
      }

      const netbankingOptions = getMethodsForPspAndType(pspCode, "NetBanking");
      if (netbankingOptions.length > 0) {
        newTypes.push({ title: "NetBanking" });
      }

      const upiOptions = getMethodsForPspAndType(pspCode, "Upi");
      if (upiOptions.length > 0) {
        newTypes.push({ title: "UPI" });
      }

      const cryptoOptions = getMethodsForPspAndType(pspCode, "Crypto");
      if (cryptoOptions.length > 0) {
        newTypes.push({ title: "Crypto" });
      }

      const PaynowOptions = getMethodsForPspAndType(pspCode, "Paynow");
      if (PaynowOptions.length > 0) {
        newTypes.push({ title: "Paynow" });
      }
      return newTypes;
    });
  }, [filteredGateways]);
  useEffect(() => {
    if (unSaved === false) {
      const items = [
        {
          title: obj.title,
          value: PspCode,
          logoUrl: obj.logoUrl,
        },
      ];

      const alldata = [
        {
          pspCode: PspCode,
          logoUrl: obj.logoUrl,
          title: obj.title,
          rules: {
            configs: [gatewayConfigs[PspCode]],
            currencyCodes: [currenciesSelected.map((obj) => obj?.name)],
            countryCode: countrySelected?.countryCode,
          },
        },
      ];
      if (pspSelected.find((ele) => ele.value === items[0].value)) {
        const newSelects = [...pspSelected, ...items];
        setPspSelected(newSelects);
        const newPayload = [...alldata];
        setPayload(newPayload);
      } else {
        const newSelects = [...pspSelected, ...items];
        setPspSelected(newSelects);
        sessionStorage.setItem("SelectedPsps", JSON.stringify(newSelects));
        const newPayload = [...payload, ...alldata];
        setPayload(newPayload);
      }
    }
  }, [
    unSaved
  ]);

  useEffect(() => {
    const id = PspCode;
    if (sessionStorage.getItem("SelectedPsps")) {
      const psp = JSON.parse(sessionStorage.getItem("SelectedPsps"));
      if (psp.find((ele) => ele.value === id)) {
        setUnSaved(false);
        if (toggle === false) {
          if (toggled === true) {
            handleOpenCM();
          } else {
            setToggle(!toggle);
            setToggled(!toggled);
          }
        }
      }
    }
  }, [pspSelected, filteredGateways]);

  const [on, setOn] = useState(false);
  const [change, setChange] = useState(false);
  const handelClick = () => {
    if (isDisabled() === true) return;

    if (toggle === false) {
      if (toggled === true) {
        handleOpenCM();
      } else {
        setToggle(!toggle);
        setToggled(!toggled);
      }
    }
  };

  const handleToggleOff = () => {
    setToggle(false);
    setToggled(false);
  };
  const handleChange = () => {
    setToggle(true);
    setToggled(true);
  };
  const [openCM, setOpenCM] = useState(false);
  const handleOpenCM = () => {
    setOpenCM(true);
  };

  const handleCloseCM = () => {
    setOpenCM(false);
  };

  const handleGatewayCreds = (gatewayCredsToUpdate) => {
    setGatewayConfigs(gatewayCredsToUpdate);
  };

  useEffect(() => {
    setGatewayConfigs(gatewayConfigs);
    setCountrySelected(countrySelected);
    setCurrenciesSelected(currenciesSelected);
  }, [gatewayConfigs, countrySelected, currenciesSelected]);

  const isDisabled = () => {
    if ((toggled && !toggle) || (pspSelected?.length > 0 && unSaved))
      return true;
    return false;
  };

  const handleYes = () => {
    setToggled(false);
    setToggle(false);
    setUnSaved(true);
    setPspSelected([]);
    setPayload([]);
    setPspSaved(false);
    sessionStorage.removeItem("SelectedPsps");
    sessionStorage.removeItem("storeCreds");
    sessionStorage.removeItem("storeOptions");
    localStorage.setItem('paymentSwitchTabs', true)
  };

  return (
    <>
      <div style={{ width: "300px" }}>
        <Card
          style={{
            height: "75px",
            padding: "13px",
            border: toggle ? "3px  solid #CAC9FB" : "3px",
            cursor: "pointer"
          }}
          onClick={handelClick}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex" }}>
              <img
                src={obj.logoUrl}
                style={{
                  height: "30px",
                  width: "46px",
                  filter: isDisabled() ? "grayscale(100%)" : "none",
                }}
              />
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <h6
                    style={{
                      marginLeft: "-9px",
                      paddingTop: "7px",
                      fontSize: "15px",
                      color: isDisabled() ? "rgba(201, 201, 204, 1)" : "black",
                    }}
                  >
                    {obj.title}
                  </h6>
                  <>
                    {!unSaved && (
                      <TaskAltIcon
                        sx={{
                          color: "rgba(36, 183, 170, 1)",
                          height: "24px",
                          width: "24px",
                          paddingTop: "7px",
                        }}
                      />
                    )}
                  </>
                </div>

                <Typography
                  style={{
                    fontSize: "11px",
                    marginLeft: "-10px",
                    color: "#595959",
                    marginTop: "2px",
                    display: "flex",
                    width: "10px",
                  }}
                >
                  {showOptions &&
                    availableTypes?.map((obj, index) => (
                      <>
                        <span
                          style={{
                            marginLeft: "3px",
                            marginTop: "-3px",
                            color: isDisabled()
                              ? "rgba(201, 201, 204, 1)"
                              : "black",
                          }}
                        >
                          {" "}
                          {obj.title}{" "}
                        </span>
                        {index < availableTypes.length - 1 && (
                          <p
                            style={{
                              marginTop: "-3px",
                              color: isDisabled()
                                ? "rgba(201, 201, 204, 1)"
                                : "black",
                            }}
                          >
                            ,
                          </p>
                        )}
                      </>
                    ))}
                </Typography>
              </div>
            </div>
            <div>
              <section
                style={{
                  border: "1.2px",
                  borderStyle: "solid",
                  borderColor: "#0101021F",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  width: "70px",
                  height: "29px",
                  padding: "2px 0px 0px 8px",
                  marginLeft: "-86px",
                  fontFamily: "Poppins",
                  cursor: "pointer",
                  color: isDisabled() || toggled ? "rgba(201, 201, 204, 1)" : "black",
                }}
                onClick={handelClick}
              >
                {/* {unSaved ? ( */}
                <AddIcon
                  style={{
                    marginTop: "-2px",
                    marginLeft: "-4px",
                    marginRight: "2px",
                    height: "18px",
                    width: "18px",
                    color: isDisabled() || toggled ? "rgba(201, 201, 204, 1)" : "black",
                  }}
                />
                {/* ) : (
                  <img
                    style={{ marginTop: "-2px", marginRight: "5px" }}
                    src="/assets/Edit.svg"
                  />
                )} */}
                Add
                {/* {unSaved ? "Add" : "Edit"} */}
              </section>
            </div>
          </div>
        </Card>
      </div>

      <div
        style={{
          width: "48%",
          position: "absolute",
          top: "200px",
          marginLeft: "25%",
        }}
      >
        {toggle && (
          <ConfigurePaymentGateways
            filteredGateways={filteredGateways}
            value={PspCode}
            pspsToConfigure={showCreds}
            initialSelection={gatewayConfigs}
            gatewayCredsHandler={handleGatewayCreds}
            unSaved={unSaved}
            setUnSaved={setUnSaved}
            countrySelected={countrySelected}
            setCountrySelected={setCountrySelected}
            currenciesSelected={currenciesSelected}
            setCurrenciesSelected={setCurrenciesSelected}
            storeCreds={storeCreds}
            setStoreCreds={setStoreCreds}
            setPspSaved={setPspSaved}
            pspSaved={pspSaved}
            handleToggleOff={handleToggleOff}
            getSupportedMethods={getSupportedMethods}
            handleYes={handleYes}
          ></ConfigurePaymentGateways>
        )}
      </div>
    </>
  );
};

export default PspCard;
